<template>
  <el-dialog
    title="身份认证"
    :visible.sync="visible"
    width="520px"
    :close-on-click-modal="false"
    :show-close="false"
    :show="show"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="120px"
      class="dialog"
      :validate-on-rule-change="false"
    >
      <el-form-item label="图片验证码：" prop="code">
        <el-input
          placeholder="请输入图片验证码"
          v-model="form.code"
          class="input-width"
        />
        <div class="login-code">
          <img :src="codeUrl" @click="getImgCode" class="login-code-img" />
        </div>
      </el-form-item>
      <el-form-item label="手机号码：" prop="mobile">
        <el-input
          placeholder="请输入手机号码"
          v-model="form.mobile"
          type="number"
          class="input-width"
          disabled
        />
        <el-button
          class="bg code-btn"
          @click="getTelCode"
          :disabled="disable"
          >{{ tipStr }}</el-button
        >
      </el-form-item>
      <el-form-item label="手机验证码：" prop="telCode">
        <el-input
          placeholder="请输入验证码"
          v-model="form.telCode"
          type="number"
          class="input-width"
        />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button class="bg" @click="handleOk">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { checkPhone } from '@/utils/rules'
import { getCodeImg, postSendSmsCode, checkSmsCode } from '@/api/submit'
import { setToken } from '@/utils/auth'
export default {
  name: 'SendMsg',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    phone: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: { mobile: '', code: '', telCode: '' },
      rules: {
        mobile: [
          { required: true, message: '请输入', trigger: 'blur' },
          {
            validator: checkPhone,
            trigger: 'change',
            message: '请输入正确的手机号'
          }
        ],
        code: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      visible: this.show,
      tipStr: '获取验证码',
      count: 60,
      time: null,
      disable: false,
      codeUrl: '' //图片验证码
    }
  },
  watch: {
    show() {
      this.visible = this.show
    },
    phone() {
      this.form = { ...this.form, mobile: this.phone }
    }
  },
  mounted() {
    this.getImgCode()
  },
  methods: {
    //获取图片验证码
    getImgCode() {
      getCodeImg().then((res) => {
        this.codeUrl =
          window.webkitURL.createObjectURL(res) ||
          window.URL.createObjectURL(res)
      })
    },
    //获取手机验证码
    getTelCode() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          //发送验证码
          let { telCode, ...obj } = this.form
          try {
            await postSendSmsCode(obj)
            this.$message({
              message: '短信发送成功。',
              type: 'success'
            })
            clearInterval(this.time)
            this.tipStr = this.count + '后重新获取'
            this.disable = true
            this.time = setInterval(() => {
              this.count--
              this.tipStr = this.count + '后重新获取'
              if (this.count == 0) {
                clearInterval(this.time)
                this.disable = false
                this.tipStr = '获取验证码'
                this.count = 60
              }
            }, 1000)
          } catch (e) {
            this.getImgCode()
          }
        }
      })
    },
    handleClose() {
      this.$emit('update:show', false)
    },
    handleOk() {
      this.$refs['form'].validate(async (valid) => {
        if (valid && this.form.telCode) {
          //验证身份
          let res = await checkSmsCode({ code: this.form.telCode })
          setToken(res.data)
          this.visible = false
          this.$message({
            message: '验证身份成功。',
            type: 'success'
          })
          this.$emit('getValidate', true)
        } else {
          this.$message({
            message: '请输入手机验证码',
            type: 'warning'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  &:hover {
    background-color: #87a86c;
    color: #ffffff;
  }
  background-color: #87a86c;
  color: #ffffff;
}
.code-btn {
  margin-left: 20px;
}
.input-width {
  width: 200px;
}
.login-code {
  display: inline-block;
  width: 110px;
  height: 38px;
  padding: 0 10px;
  margin-left: 10px;

  .login-code-img {
    width: 100%;
    height: 38px;
    cursor: pointer;
    vertical-align: middle;
  }
}
</style>
